import { render, staticRenderFns } from "./flowShipmentAct.vue?vue&type=template&id=a2d52cac&scoped=true"
import script from "./flowShipmentAct.vue?vue&type=script&lang=js"
export * from "./flowShipmentAct.vue?vue&type=script&lang=js"
import style0 from "./flowShipmentAct.vue?vue&type=style&index=0&id=a2d52cac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d52cac",
  null
  
)

export default component.exports